export const searchSettings = {
  searchTermParam: 'searchTerm',
  searchClusterParam: 'searchCluster',
  searchPageParam: 'page',
  itemsPerPage: 48
};
